module.exports = __webpack_public_path__ + "static/media/chicken.94da0196.jpeg";